import React from 'react';
import { Box, Button, Callout, Flex, Heading } from '@radix-ui/themes';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Box style={{ padding: 'var(--space-6)' }}>
          <Flex direction="column" gap="4" align="center" style={{ maxWidth: 600, margin: '0 auto' }}>
            <Heading size="6">Något gick fel</Heading>
            <Callout.Root color="red">
              <Callout.Text>
                Ett oväntat fel har inträffat. Försök att ladda om sidan.
              </Callout.Text>
            </Callout.Root>
            {this.state.error && (
              <Box
                style={{
                  width: '100%',
                  padding: 'var(--space-3)',
                  backgroundColor: 'var(--gray-a3)',
                  borderRadius: 'var(--radius-2)',
                  fontFamily: 'monospace',
                  fontSize: '0.875rem',
                  overflow: 'auto',
                }}
              >
                {this.state.error.message}
              </Box>
            )}
            <Button size="3" onClick={this.handleReload}>
              Ladda om sidan
            </Button>
          </Flex>
        </Box>
      );
    }

    return this.props.children;
  }
}
